import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

function obterUsuarioLocalStorage() {
  try {
    const texto = localStorage.getItem('usuario');
    if (!texto) return null;
    const usuario = JSON.parse(texto);
    return usuario && typeof usuario === 'object' ? usuario : null;
  } catch {
    return null;
  }
}

export default function App() {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [usuario, setUsuario] = useState(() => obterUsuarioLocalStorage());

  useEffect(() => {
    // Verifica se o token ainda é válido e sincroniza os dados do usuário.
    if (token) {
      fetch('/api/auth/verify', {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(async (res) => {
          if (!res.ok) {
            setToken(null);
            setUsuario(null);
            localStorage.removeItem('token');
            localStorage.removeItem('usuario');
            return null;
          }

          return res.json();
        })
        .then((dados) => {
          if (!dados?.usuario) return;
          setUsuario(dados.usuario);
          localStorage.setItem('usuario', JSON.stringify(dados.usuario));
        })
        .catch(() => {
          setToken(null);
          setUsuario(null);
          localStorage.removeItem('token');
          localStorage.removeItem('usuario');
        });
    }
  }, [token]);

  const handleLogin = (newToken, novoUsuario) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);

    if (novoUsuario) {
      localStorage.setItem('usuario', JSON.stringify(novoUsuario));
      setUsuario(novoUsuario);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    setToken(null);
    setUsuario(null);
  };

  if (!token) {
    return <Login onLogin={handleLogin} />;
  }

  return <Dashboard token={token} usuario={usuario} onLogout={handleLogout} />;
}
